import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/organizations/detail';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

const unwrap = (res) => (res && res.data && res.data.data !== undefined ? res.data.data : (res && res.data) || {});

// Loads /organization/<id> and — for admins (includeSso) — the SSO config
// too, in one sequential flow. A failed SSO read (403 for non-admins) just
// yields sso: null.
export function* operation(action) {
  const { orgId, includeSso } = action.payload;
  try {
    const res = yield call(
      axios.get,
      `${config.API_URL}/organization/${orgId}`,
      { headers: getLocalUser() },
    );
    const org = unwrap(res);
    let sso = null;
    if (includeSso) {
      try {
        const sres = yield call(
          axios.get,
          `${config.API_URL}/organization/${orgId}/sso`,
          { headers: getLocalUser() },
        );
        sso = unwrap(sres);
      } catch (_e) {
        sso = null;
      }
    }
    yield put(fetchSuccess({ org, ssoRequested: Boolean(includeSso), sso }));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.message || 'Could not load organization';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
